module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-700-c657c84f5f668690e3b901860f3b6fef.svg";